module.exports = __webpack_public_path__ + "static/media/WHAT WE DO_.156a9629.jpg";